<template>
  <div class="registration-verification">
    <div ref="widget" data-register-human-verification aria-label="安全验证"></div>
    <div v-if="error" role="status" class="verification-error">
      {{ error }} <button type="button" @click="retry">重新验证</button>
    </div>
    <div v-else-if="!ready" class="verification-hint">请先完成人机验证，再点击{{ action === 'login' ? '登录' : '注册' }}</div>
  </div>
</template>

<script>
import { request } from '@/axios/request'
import { mountRegistration } from '@/utils/turnstile'
export default {
  props: { action: { type: String, default: 'signup', validator: value => ['signup', 'login'].includes(value) } },
  data: () => ({ ready: false, error: '' }),
  mounted () { this.retry() },
  beforeDestroy () {
    this.stopped = true
    if (this.owner) this.owner.dispose()
  },
  methods: {
    state (ready, error) {
      if (this.stopped) return
      this.ready = ready; this.error = error
      this.$emit('ready', ready)
    },
    async retry () {
      if (this.loading) return
      this.loading = true
      this.state(false, '')
      if (this.owner) this.owner.dispose()
      try {
        const { result } = await request('/user/human_config', 'get', undefined, 15000)
        if (this.stopped) return
        if (!result || typeof result.enabled !== 'boolean') throw new Error()
        if (!result.enabled) { this.state(true, ''); return }
        if (!result.sitekey) throw new Error()
        this.owner = mountRegistration(this.$refs.widget, result.sitekey, this.state, this.action)
      } catch (error) { this.state(false, '安全验证加载失败') }
      finally { this.loading = false }
    }
  }
}
</script>

<style scoped>
.registration-verification { margin: 0 0 16px; min-height: 65px; font-size: 13px; }
.verification-hint { margin-top: 6px; color: #909399; }
.verification-error { margin-top: 6px; color: #d95040; }
.verification-error button { border: 0; background: none; color: #409eff; cursor: pointer; }
</style>
